import { environment } from "@env/environment";
import { configureQaLocalEndpoints } from "@env/qa-local-endpoints";
import * as Sentry from "@sentry/angular";
import { installChunkLoadErrorRecovery } from "@utils/chunk-load-recovery.utils";

import { registerLocaleData } from "@angular/common";
import localeIt from "@angular/common/locales/es-CL";
import localeItExtra from "@angular/common/locales/extra/es-CL";
import { bootstrapApplication } from "@angular/platform-browser";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

configureQaLocalEndpoints();
installChunkLoadErrorRecovery();

const isLoopbackHost =
  location.hostname === "localhost" ||
  location.hostname.endsWith(".localhost") ||
  location.hostname === "127.0.0.1" ||
  location.hostname === "[::1]";

if (environment.SENTRY_ENV !== "development" && !isLoopbackHost) {
  Sentry.init({
    dsn: "https://229f57a85afb1c4fa6289d936b31c3bb@o4510619740930048.ingest.us.sentry.io/4510665754083328",
    environment: environment.SENTRY_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
      }),
    ],
    ignoreSpans: [
      {
        name: /^GET https:\/\/server\.arcgisonline\.com\/ArcGIS\/rest\/services\/World_Imagery\/MapServer\/tile\//,
        op: "http.client",
      },
    ],
    tracesSampleRate: environment.PROD ? 0.1 : 1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true,
    tracePropagationTargets: [
      /^https:\/\/iot\.rioingenieria\.cl/,
      /^https:\/\/iot-sta\.rioingenieria\.cl/,
    ],
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
registerLocaleData(localeIt, "es-CL", localeItExtra);
